'use strict';

export default class GrpAtrTypeViewCtrl {
  constructor($stateParams, $state, GrpAtrTypeSvc, GroupAuthSvc, LoaderSvc) {
    var that = this;
    this.groupId = $stateParams.groupId; // current group
    this.ptId = $stateParams.ptId; // current group

    if(!this.ptId) {
      return $state.go('group.view.settings.groupAttributeType.list');
    }

    // authorization
    GroupAuthSvc.validatePermission(this.groupId, 'groupAttributeType', 'R');

    //load groupAttribute
    function loadGrpAtrType() {
      LoaderSvc.start();
      GrpAtrTypeSvc.get({groupId: that.groupId, id: that.ptId}).$promise
        .then(function(groupAttribute) {
          that.groupAttribute = groupAttribute;
          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading Group Attribute');
        });
    }
    loadGrpAtrType();
  }
}

GrpAtrTypeViewCtrl.$inject = [
  '$stateParams',
  '$state',
  'GrpAtrTypeSvc',
  'GroupAuthSvc',
  'LoaderSvc'
];
